import React from "react";
// import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
// import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import AdminArnsContent from "./components/adminArnsContent";

function AdminArns() {
  return (
    <div
      style={{
        paddingBlock: "25px",
      }}
    >
      <div
        style={{
          fontFamily: "var(--font-family-bold)",
          fontStyle: "normal",
          fontWeight: 700,
          fontSize: "24px",
          position: "relative",
          padding: "16px",
          color: "#3d4576",
          flexDirection: "column",
          textAlign: "left",
          justifyContent: "center",
          alignItems: "center",
          width: "75%",
          height: "auto",
        }}
      >
        Accepted & Rejected Quantity Notes
      </div>
      {/* <StepperContentHolder> */}
      <AdminArnsContent />
      {/* </StepperContentHolder> */}
    </div>
  );
}

export default AdminArns;
